import React, { useState } from 'react';
import './CheckoutPage.css';

const CheckoutPage = () => {
    const [showBasic, setShowBasic] = useState(false);
    const [showStandard, setShowStandard] = useState(false);
    const [showPremium, setShowPremium] = useState(false);

    const handleRedirect = (paymentLinkUrl: string) => {
        window.location.href = paymentLinkUrl;
    };

    return (
        <div className="checkout-container">
            <h1>Elige tu suscripción</h1>
            <div className="plans">

                {/* Plan Básico */}
                <div className="plan-card">
                    <h2>Plan Básico</h2>
                    <p>Accede a las funcionalidades básicas para crear contenido automáticamente.</p>
                    <ul>
                        <li>Generación automática de textos</li>
                        <li>Creación de imágenes simples</li>
                        <li>Análisis de palabras clave</li>
                        <li>Traducción automática de contenidos</li>
                        <li>Edición básica de imágenes</li>
                    </ul>
                    {showBasic && (
                        <ul className="extra-features">
                            <li>Corrección automática de errores gramaticales</li>
                        </ul>
                    )}
                    <div className='buttons-checkout'>
                        <button onClick={() => setShowBasic(!showBasic)}>
                            {showBasic ? 'Ver menos' : 'Ver más'}
                        </button>
                        <div className="precio">
                           10€
                        </div>
                        <button 
                            onClick={() => handleRedirect('https://buy.stripe.com/00g3cce6u4Yz96U5kk')}
                            className="checkout-button">
                            Comprar Básico
                        </button>
                    </div>
                </div>

                {/* Plan Estándar */}
                <div className="plan-card">
                    <h2>Plan Estándar</h2>
                    <p>Accede a más herramientas y funcionalidades avanzadas.</p>
                    <ul>
                        <li>Generación automática de textos avanzados</li>
                        <li>Creación de imágenes personalizadas</li>
                        <li>Optimización de SEO para contenidos</li>
                        <li>Programación de publicaciones</li>
                        <li>Detección de tendencias</li>
                    </ul>
                    {showStandard && (
                        <ul className="extra-features">
                            <li>Generación automática de videos cortos</li>
                            <li>Monitorización de redes sociales</li>
                            <li>Edición avanzada de imágenes</li>
                            <li>Análisis de sentimiento</li>
                            <li>Asistente de marketing de contenidos</li>
                        </ul>
                    )}
                    <div className='buttons-checkout'>
                        <button onClick={() => setShowStandard(!showStandard)}>
                            {showStandard ? 'Ver menos' : 'Ver más'}
                        </button>
                        <div className="precio">
                            25€
                        </div>
                        <button 
                            onClick={() => handleRedirect('https://buy.stripe.com/cN29AA7I60Ij3MA6oq')}
                            className="checkout-button">
                            Comprar Estándar
                        </button>
                    </div>
                </div>

                {/* Plan Premium */}
                <div className="plan-card">
                    <h2>Plan Premium</h2>
                    <p>Accede a todas las funcionalidades para maximizar tu creatividad con IA.</p>
                    <ul>
                        <li>Generación automática de contenido para múltiples plataformas</li>
                        <li>Creación de imágenes ultra personalizadas</li>
                        <li>Optimización SEO avanzada</li>
                        <li>Gestión de proyectos de contenido</li>
                        <li>Automatización completa del marketing</li>
                    </ul>
                    {showPremium && (
                        <ul className="extra-features">
                            <li>Automatización de embudos de ventas</li>
                            <li>Generación automática de presentaciones</li>
                            <li>Edición avanzada de videos</li>
                            <li>Generación de contenido interactivo</li>
                            <li>Generación de informes detallados</li>
                        </ul>
                    )}
                    <div className='buttons-checkout'>
                        <button onClick={() => setShowPremium(!showPremium)}>
                            {showPremium ? 'Ver menos' : 'Ver más'}
                        </button>
                        <div className="precio">
                            50€
                        </div>
                        <button 
                            onClick={() => handleRedirect('https://buy.stripe.com/9AQ8ww0fE2Qr5UIaEF')}
                            className="checkout-button">
                            Comprar Premium
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default CheckoutPage;
